import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {}
};

// Config slice
export const userAuth = createSlice({
  name: 'userAuth',
  initialState,
  reducers: {
    loginAction: (state, action) => {
      state.user = action?.payload;
    }
  }
});

// Export actions
export const { loginAction } = userAuth.actions;

// Right now is not in use.
export const selectUser = (state) => state.user;
